import { render, staticRenderFns } from "./PriceListTable.vue?vue&type=template&id=4e881742&"
import script from "./PriceListTable.vue?vue&type=script&lang=js&"
export * from "./PriceListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports